import styled from '../../../theme/styled-with-theme';

import { Box } from '../../Box';
import { GlImage } from '../../Image';
import Link from '../../Link';

export const AnchorLink = styled(Link)`
  flex: 1 1 auto;
  text-decoration: none;
  color: ${({ theme }) => theme.color.black};
`;

export const StyledImage = styled(GlImage)`
  border-radius: ${({ theme }) => theme.borderRadius.quickStartGuideBox};
`;

export const TextWrapper = styled(Box)`
  margin-top: -${({ theme }) => theme.spacing.xl};
`;
